// extracted by mini-css-extract-plugin
export default {"logo":"lazyLogos_logo__lUlDm"};